// 日時のローケール対応
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)

export function convertUtcToLocalText(utcString, format = 'YYYY-MM-DD HH:mm:ss') {
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone
  console.log(`Converting UTC to local time: ${dayjs.utc(utcString).tz(tz).format(format)} in timezone: ${tz}`)
  return dayjs.utc(utcString).tz(tz).format(format)
}

export function convertLocalTextToUtc(localString, format = 'YYYY-MM-DD HH:mm:ss') {
  const userTz = Intl.DateTimeFormat().resolvedOptions().timeZone
  return dayjs.tz(localString, format, userTz).utc().format()
}
